import React from 'react';

import NrgComponent from './../NrgComponent.jsx';
import getIcon from '../../icons/svgController.js';

export default class PeoplePopup extends NrgComponent {

  render() {
    var icon = (this.props.direction === 'left') ? 'arrow-left' : 'arrow-right';
    let Icon = getIcon(icon);
    var click = (this.props.direction === 'left')
      ? () => this.props.actions.navigateLeft()
      : () => this.props.actions.navigateRight()
    ;
    var hidden = (this.props.showing === false) ? 'invisible' : '';

    return (
      <div className={`NavigationArrow ${this.props.direction} ${hidden}`} onClick={click}>
        {icon && <Icon viewBox="0 0 97.3 72.3"></Icon>}
      </div>
    );
  }

};
